import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, History, Wallet, FileText, Receipt, FileClock } from "lucide-react";
import CustomerDashboard from "./CustomerDashboard";
import CustomerHistory from "./CustomerHistory";
import CustomerOrderDetail from "./CustomerOrderDetail";
import PortalWallet from "./finance/PortalWallet";
import PortalInvoices from "./finance/PortalInvoices";
import PortalCreditNotes from "./finance/PortalCreditNotes";
import PortalStatements from "./finance/PortalStatements";

const OP_SECTION = {
  label: "My account",
  items: [
    { to: "/portal", end: true, label: "Overview", icon: <LayoutDashboard size={16} />, testId: "nav-portal-dashboard" },
    { to: "/portal/history", label: "History", icon: <History size={16} />, testId: "nav-portal-history" },
  ],
};

const FIN_SECTION = {
  label: "Finance",
  items: [
    { to: "/portal/wallet", label: "My Wallet", icon: <Wallet size={16} />, testId: "nav-portal-wallet" },
    { to: "/portal/invoices", label: "Invoices", icon: <FileText size={16} />, testId: "nav-portal-invoices" },
    { to: "/portal/credit-notes", label: "Credit Notes", icon: <Receipt size={16} />, testId: "nav-portal-credit-notes" },
    { to: "/portal/statements", label: "Statements", icon: <FileClock size={16} />, testId: "nav-portal-statements" },
  ],
};

export default function CustomerLayout() {
  const { tenant } = useAuth();
  const financialOn = tenant?.plan === "financial"
    && !!tenant?.feature_flags?.financial;

  // Only show finance nav when tenant has finance features enabled.
  // Backend enforces this too — nav-hiding is UX only.
  const sections = financialOn ? [OP_SECTION, FIN_SECTION] : [OP_SECTION];

  return (
    <AppShell
      brand={{ title: "Customer Portal", subtitle: "Self-service" }}
      sections={sections}
      testIdPrefix="portal"
    >
      <Routes>
        <Route index element={<CustomerDashboard />} />
        <Route path="history" element={<CustomerHistory />} />
        <Route path="orders/:id" element={<CustomerOrderDetail />} />
        {financialOn && <Route path="wallet" element={<PortalWallet />} />}
        {financialOn && <Route path="invoices" element={<PortalInvoices />} />}
        {financialOn && <Route path="credit-notes" element={<PortalCreditNotes />} />}
        {financialOn && <Route path="statements" element={<PortalStatements />} />}
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
    </AppShell>
  );
}
